import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';

export default function InviteTeamMembers() {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [form, setForm] = useState({ invitee_name: '', invitee_email: '', invitee_role: 'trainer' });
  const [generating, setGenerating] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!isAdmin) { navigate('/'); return; }
    api.get('/settings/invite/status').then(setStatus).catch(() => {});
  }, [isAdmin, navigate]);

  async function handleGenerate(e) {
    e.preventDefault();
    setGenerating(true); setError(''); setResult(null);
    try {
      const data = await api.post('/settings/invite', form);
      setResult(data);
      setStatus(s => s ? { ...s, count: s.count + 1 } : s);
      setForm({ invitee_name: '', invitee_email: '', invitee_role: 'trainer' });
    } catch (err) {
      setError(err.message);
    } finally {
      setGenerating(false);
    }
  }

  function copyCode() {
    navigator.clipboard.writeText(result.code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  const atLimit = status && status.count >= status.limit;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg)' }}>
      <div className="page-header">
        <h1>
          <button className="icon-btn" style={{ marginRight: 4 }} onClick={() => navigate(-1)}>
            <span style={{ fontSize: 22, color: 'var(--color-text)' }}>‹</span>
          </button>
          Invite Team Members
        </h1>
      </div>

      <div className="page-content">
        {status && (
          <div className="card" style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 14, color: 'var(--color-text-muted)' }}>Team members</span>
            <span style={{ fontSize: 16, fontWeight: 700 }}>{status.count} / {status.limit}</span>
          </div>
        )}

        {atLimit && (
          <div style={{ background: 'rgba(243,156,18,0.1)', border: '1px solid rgba(243,156,18,0.3)', color: '#F39C12', borderRadius: 'var(--radius)', padding: '14px 16px', fontSize: 14, marginBottom: 16 }}>
            Team limit reached. Upgrade your plan to add more members.
          </div>
        )}

        {error && <div className="error-msg">{error}</div>}

        {result ? (
          <div className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 13, color: 'var(--color-text-muted)', marginBottom: 16 }}>Invite code generated for <strong style={{ color: 'var(--color-text)' }}>{result.invitee_name}</strong></div>
            <div style={{ fontSize: 40, fontWeight: 900, letterSpacing: 6, color: 'var(--color-primary)', background: 'rgba(215,38,56,0.08)', borderRadius: 12, padding: '20px 16px', marginBottom: 12, fontFamily: 'monospace' }}>
              {result.code}
            </div>
            <div style={{ fontSize: 13, color: 'var(--color-text-muted)', marginBottom: 20 }}>
              This code expires in 72 hours. Share it with {result.invitee_name} to complete their registration.
            </div>
            <button onClick={copyCode} className="btn btn-primary" style={{ marginBottom: 12 }}>
              {copied ? '✓ Copied!' : 'Copy Code'}
            </button>
            <button onClick={() => setResult(null)} className="btn btn-ghost">Generate Another</button>
          </div>
        ) : (
          !atLimit && (
            <div className="card">
              <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 16 }}>New Invite</div>
              <form onSubmit={handleGenerate}>
                <div className="form-group">
                  <label className="form-label">Team Member Name *</label>
                  <input className="form-input" placeholder="Full name" value={form.invitee_name} onChange={e => setForm(f => ({ ...f, invitee_name: e.target.value }))} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Email Address *</label>
                  <input className="form-input" type="email" placeholder="email@example.com" value={form.invitee_email} onChange={e => setForm(f => ({ ...f, invitee_email: e.target.value }))} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Role *</label>
                  <select className="form-select" value={form.invitee_role} onChange={e => setForm(f => ({ ...f, invitee_role: e.target.value }))}>
                    <option value="trainer">Trainer</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <button className="btn btn-primary" type="submit" disabled={generating || !form.invitee_name || !form.invitee_email}>
                  {generating ? 'Generating...' : 'Generate Code'}
                </button>
              </form>
            </div>
          )
        )}
      </div>
    </div>
  );
}
